<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulasInfantis',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
              <e-label>Tipo de aula</e-label>
              <e-autocomplete
                :items="$constants.tiposDeAulas"
                :return-object="false"
                :error-messages="errors"
                v-model="aulaSelecionada.tipo_de_aula"
                @change="() => verificaTipoDaAula()"
                label="Selecione um tipo de aula"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row v-if="mostrarCampos">
          <v-col class="pt-0 pb-0" cols="6">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="data"
              persistent
              width="450px"
            >
              <template v-slot:activator="{ on, attrs }">
                <e-label>Selecione uma data</e-label>
                <v-text-field
                  v-model="aulaSelecionada.data"
                  persistent-hint
                  :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                  label="Escolha uma data"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  solo
                  @change="() => pesquisaAulas()"
                ></v-text-field>
              </template>

              <v-card>
                <v-container class="calendar-container">
                  <v-row>
                    <v-col cols="12" md="12" class="d-flex justify-center">
                      <v-card class="calendar-card pa-3" elevation="2" outlined>
                        <v-date-picker
                          v-model="data"
                          full-width
                          scrollable
                          :allowed-dates="allowedDates"
                          :events="[
                            ...feriados.map((f) => f.data),
                            ...sabadosLetivos.map((s) => s.data),
                          ]"
                          :event-color="getEventColor"
                          @update:picker-date="atualizarMesVisivel"
                          color="primary"
                          header-color="primary"
                        >
                          <template v-slot:day="{ date, day }">
                            <v-badge
                              :color="getBadgeColor(date)"
                              :content="getBadgeContent(date)"
                              overlap
                              dot
                            >
                              <span>{{ day }}</span>
                            </v-badge>
                          </template>
                        </v-date-picker>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <v-card class="events-card" elevation="2" outlined>
                        <v-card-title class="primary white--text pa-4">
                          <v-icon left color="white">mdi-calendar-month</v-icon>
                          Eventos do Mês
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-list dense class="py-0">
                          <template v-for="(evento, index) in eventosFiltradosPorMes">
                            <v-divider v-if="index > 0" :key="`divider-${index}`"></v-divider>
                            <v-list-item :key="index" class="px-4">
                              <v-list-item-icon class="mr-3">
                                <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="d-flex align-center">
                                  <span class="date-label mr-2">{{
                                    formatarDia(evento.data)
                                  }}</span>
                                  <span>
                                    {{ evento.descricao }}
                                    <v-chip
                                      v-if="
                                        evento.is_sabado_letivo === true ||
                                        evento.is_sabado_letivo === 1
                                      "
                                      x-small
                                      color="green"
                                      class="ml-2 white--text"
                                      dark
                                    >
                                      Dia Letivo
                                    </v-chip>
                                    <v-chip
                                      v-if="
                                        evento?.is_sabado_letivo === false ||
                                        evento?.is_sabado_letivo === 0
                                      "
                                      x-small
                                      color="red"
                                      class="ml-2 white--text"
                                      dark
                                    >
                                      Dia não letivo
                                    </v-chip>
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>

                          <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                            <v-list-item-content>
                              <v-list-item-title class="text-caption grey--text">
                                Nenhum evento neste mês
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(data)">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Dia da semana</e-label>
            <v-text-field solo dense v-model="aulaSelecionada.dia_da_semana" :disabled="true">
            </v-text-field>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6" v-if="aulaSelecionada.tipo_de_aula === 'Reposição'">
            <v-dialog
              ref="dialog_reposicao"
              v-model="modal_reposicao"
              :return-value.sync="data_reposicao"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <e-label>Selecione uma data Reposição</e-label>
                <v-text-field
                  v-model="aulaSelecionada.data_reposicao"
                  persistent-hint
                  :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                  label="Escolha uma data"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="data_reposicao"
                scrollable
                :min="inicioPeriodoEtapa"
                :max="fimPeriodoEtapa"
                :allowed-dates="allowedDatesReposicao"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal_reposicao = false"> Cancel </v-btn>
                <v-btn text color="primary" @click="$refs.dialog_reposicao.save(data_reposicao)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6" v-if="aulaSelecionada.tipo_de_aula === 'Reposição'">
            <e-label>Dia da Semana Reposto</e-label>
            <v-text-field
              solo
              dense
              v-model="aulaSelecionada.dia_da_semana_reposicao"
              :disabled="true"
            >
            </v-text-field>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
              <e-label>Selecione um horário</e-label>
              <e-autocomplete
                :disabled="aulaSelecionada.data ? false : true"
                :items="horarios"
                :item-text="(item) => item.descricao"
                :return-object="false"
                :item-value="(item) => item.id"
                :error-messages="errors"
                v-model="horarios_infantis"
                label="Selecione uma opção"
                dense
                multiple
                @change="() => pesquisaAulas()"
              />
            </ValidationProvider>
            <!-- @change="() => pesquisaAulas()" -->
          </v-col>

          <ValidationProvider name="experiências" rules="required" v-slot="{ errors }">
            <v-col cols="12">
              <v-col class="pt-0 pb-0" cols="12">
                <h4>Campos de experiências</h4>
                <v-row class="">
                  <v-col class="pt-0 pb-0" cols="4" v-for="(el, index) of opcoes" :key="index">
                    <v-checkbox
                      v-model="campos_de_experiencias"
                      :label="el"
                      :value="el"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <span class="red--text">{{ errors[0] }}</span>
              </v-col>
            </v-col>
          </ValidationProvider>

          <v-col
            cols="12"
            v-if="
              horarios_infantis ||
              aulaSelecionada.tipo_de_aula === 'Aula Remota' ||
              editing ||
              outrosCampos
            "
          >
            <ValidationProvider name="temas" rules="required" v-slot="{ errors }">
              <e-label>Temas integrados</e-label>
              <v-textarea solo dense v-model="aulaSelecionada.eixos" :error-messages="errors" />
            </ValidationProvider>

            <ValidationProvider name="possibilidades" rules="required" v-slot="{ errors }">
              <e-label>Possibilidades pedagógicas</e-label>
              <v-textarea
                solo
                dense
                v-model="aulaSelecionada.estrategias"
                :error-messages="errors"
              />
            </ValidationProvider>

            <!-- <ValidationProvider name="recursos" rules="required" v-slot="{ errors }">
              <e-label>Recursos</e-label>
              <v-textarea solo dense v-model="aulaSelecionada.recursos" :error-messages="errors" />
            </ValidationProvider>

            <ValidationProvider name="atividade_classe" rules="required" v-slot="{ errors }">
              <e-label>Atividade de classe</e-label>
              <v-textarea
                solo
                dense
                v-model="aulaSelecionada.atividade_classe"
                :error-messages="errors"
              />
            </ValidationProvider>

            <ValidationProvider name="atividade_casa" rules="required" v-slot="{ errors }">
              <e-label>Atividade de casa</e-label>
              <v-textarea
                solo
                dense
                v-model="aulaSelecionada.atividade_casa"
                :error-messages="errors"
              />
            </ValidationProvider> -->

            <e-label>Observações</e-label>
            <v-textarea solo dense v-model="aulaSelecionada.observacoes" />
            <v-btn
              color="primary"
              :disabled="submittingForm || !outrosCampos"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
            <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.duplicar = true"
              >Duplicar Aula</v-btn
            >
            <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.exportar = true"
              >Exportar Aula</v-btn
            >
          </v-col>
        </v-row>

        <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado">
          <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
            <v-alert type="warning" border="left">
              Por favor, preencha os campos obrigatórios!
            </v-alert>
          </v-col>
        </v-row>
      </form>

      <v-bottom-sheet v-model="mostrarSheetConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="fecharSheetConflitos"> Fechar </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horarios_descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <!-- <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula> -->
    <e-modal-duplicar-aula-infantil
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAula="gestaoDeAula"
      :form="{ ...aulaSelecionada }"
      :datasPermitidas="allowedDates"
      :aulasEmConflitos="aulasEmConflitos"
      @dialogChange="handleDuplicarDialogChange($event)"
      @checarConflitos="pesquisaAulas($event)"
    >
    </e-modal-duplicar-aula-infantil>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      const todosEventos = [
        ...this.feriados.map((f) => ({ ...f, tipo: "naoEhLetivo" })),
        ...this.sabadosLetivos.map((s) => ({ ...s, tipo: "EhLetivo" })),
      ];
      return todosEventos
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2], 10) - parseInt(b.data.split("-")[2], 10);
        });
    },
  },
  async mounted() {
    await this.buscarTodosHorarios();
    this.loadData();
    await this.carregarFeriados();

    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
  },
  data() {
    return {
      opcoes: [
        "O eu, o outro e o nós",
        "Corpo, gestos e movimentos",
        "Escuta, fala, pensamento e imaginação",
        "Traços, sons, cores e formas",
        "Espaço, tempo, quantidades, relações e transformações",
      ],
      mostrarSheetConflitos: false,
      data: null,
      data_reposicao: "",
      modal: false,
      modal_reposicao: false,
      menu: false,
      aulasEmConflitos: false,
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      aulasConflitadas: [],
      diasSemana: this.$constants.diasDaSemana,
      mostrarCampos: true,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      campos_de_experiencias: [],
      aulaSelecionada: {
        data: "",
        data_reposicao: "",
        dia_da_semana: null,
        dia_da_semana_reposicao: null,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarios_infantis: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      feriados: [],
      eventosLetivosDia: [],
      eventosQueBloqueiamAulas: [],
      sabadosLetivos: [],
      mesVisivel: null,
    };
  },
  watch: {
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
    data_reposicao(value) {
      const dataFormatada = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));

      this.aulaSelecionada.data_reposicao = dataFormatada;
      this.aulaSelecionada.dia_da_semana_reposicao = "Sábado";
    },
    data(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
      this.diaDaSemana();
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());
      this.pesquisaAulas();
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana, dataSelecionada = this.data) {
      const toYMD = (v) => {
        if (!v) return "";
        if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
        const d = v instanceof Date ? v : new Date(v);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate()
        ).padStart(2, "0")}`;
      };

      const dataFormatada = toYMD(dataSelecionada);
      const eventos = this.todosEventos || [];
      const evento = eventos.find((ev) => toYMD(ev.data) === dataFormatada);

      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
            await this.buscarTodosHorarios();
          }
          this.horarios = this.todosHorariosDisponiveis || [];
          this.horariosDoComponente = this.todosHorariosDisponiveis || [];
          return;
        }
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      if (!this.gestaoDeAula?.relacoesDiasHorarios) {
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);

      this.horarios = horariosDoDia;
      this.horariosDoComponente = horariosDoDia;
    },
    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();

        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },
    async pesquisaAulas(payloadDuplicarExportar) {
      let data_aula;
      let horariosIds;
      let turma_id;
      let aula_id;

      if (payloadDuplicarExportar) {
        data_aula = payloadDuplicarExportar.data_aula;
        horariosIds = payloadDuplicarExportar.horariosIds;
        turma_id = payloadDuplicarExportar.turma_id;
        aula_id = null;
      } else {
        data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
        horariosIds = this.horarios_infantis;
        turma_id = this.gestaoDeAula.turma.id;
        aula_id = this.editing ? this.$route.params.aula_id : null;
      }

      if (!data_aula || !horariosIds || !turma_id) return;

      const payload = {
        data_aula,
        horariosIds,
        turma_id,
        aula_id: aula_id || null,
      };

      const response = await this.$services.aulasService.pesquisarAulasEmConflitosInfantil(payload);

      const conflitosExistentes = response.data || [];

      this.aulasConflitadas = conflitosExistentes;
      this.aulasEmConflitos = conflitosExistentes.length > 0;
      this.mostrarSheetConflitos = conflitosExistentes.length > 0;

      if (conflitosExistentes.length === 0) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
      }
    },

    fecharSheetConflitos() {
      this.mostrarSheetConflitos = false;
    },
    handleDuplicarDialogChange(event) {
      if (typeof event === "object" && event !== null) {
        this.dialog.duplicar = event.open;
        if (!event.wasDuplicated) {
          this.pesquisaAulas();
        }
      } else {
        this.dialog.duplicar = event;
      }
    },

    allowedDates(val) {
      const toYMD = (v) => {
        if (!v) return "";
        if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
        const d = v instanceof Date ? v : new Date(v);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate()
        ).padStart(2, "0")}`;
      };

      const dataFormatada = toYMD(val);
      const evento = (this.todosEventos || []).find((ev) => toYMD(ev.data) === dataFormatada);

      if (evento) {
        if (evento.is_feriado) return false;
        if (evento.is_sabado_letivo) return true;
        return false;
      }

      const diaDaSemana = new Date(dataFormatada).getDay();
      if (!this.diasPermitidosParaCriarAula.includes(diaDaSemana)) return false;

      return true;
    },
    toYMD(v) {
      if (!v) return "";
      if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },
    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();

        this.feriados = response
          .filter((evento) => evento.evento.is_sabado_letivo === false)
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
            is_feriado: evento.evento?.is_feriado,
            is_sabado_letivo: evento.evento?.is_sabado_letivo,
          }));

        this.sabadosLetivos = response
          .filter((evento) => evento.evento.is_sabado_letivo === true)
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
            is_feriado: evento.evento?.is_feriado,
            is_sabado_letivo: evento.evento?.is_sabado_letivo,
          }));

        this.todosEventos = [...this.feriados, ...this.sabadosLetivos];
      } catch (error) {
        this.$handleError(error);
      }
    },
    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
    },
    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },
    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },
    isSabadoLetivo(date) {
      return this.sabadosLetivos.some((s) => s.data === date);
    },
    getBadgeColor(date) {
      if (this.isFeriado(date)) return "red";
      if (this.isSabadoLetivo(date)) return this.getEventColor(date);
      return "";
    },
    getBadgeContent(date) {
      if (this.isFeriado(date)) return "F";
      if (this.isSabadoLetivo(date)) return "S";
      return "";
    },
    getEventColor(date) {
      const cores = [];
      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) cores.push(feriado.cor);
      const sabado = this.sabadosLetivos.find((s) => s.data === date);
      if (sabado) cores.push(sabado.cor);
      return cores.length > 0 ? cores : "red";
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      await this.getHorarios();
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async submitForm() {
      this.aulaSelecionada.horarios_infantis = this.horarios_infantis;
      this.aulaSelecionada.e_aula_infantil = 1;
      this.aulaSelecionada.campos_de_experiencias = this.campos_de_experiencias;
      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
            this.aulaSelecionada.data_reposicao = this.aulaSelecionada.data_reposicao
              .split("/")
              .reverse()
              .join("-");
          }
          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
            this.aulaSelecionada.data_reposicao = this.aulaSelecionada.data_reposicao
              .split("/")
              .reverse()
              .join("-");
          }
          await this.$services.aulasService.criarAula(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      this.$router.push({
        name: "aulasInfantis",
      });
    },
    async getAula() {
      await this.getHorarios();
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.gestaoDeAula = response.payload.gestaoDeAula;
      const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;

      this.horariosSabado = response.payload.horarios.filter((h) => h.turno_id === turnoIdTurma);
      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));

      this.horarios_infantis = aulaSelecionada.horarios_infantis;
      this.campos_de_experiencias = aulaSelecionada.campos_de_experiencias
        ? aulaSelecionada.campos_de_experiencias
        : [];

      this.aulaSelecionada.data = aulaSelecionada.data;
      this.data = aulaSelecionada.data;
      const diaSemana = new Date(this.data).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaSemana);

      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
        this.horariosSabado = this.horarios;
        this.horariosSabado = this.horariosSabado.map((h) => {
          return {
            id: h.id,
            turno_id: h.turno_id,
            descricao: h.descricao.split(" - ")[0],
            final: h.final,
            inicio: h.inicio,
          };
        });
        this.horariosDoComponente =
          new Date(this.data).getDay() === 5 ? this.horariosSabado : this.horarios;
      }

      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.buscarTodosHorarios();
        await this.getHorarios();
        this.aulaSelecionada = await this.getAula();
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        if (this.aulaSelecionada.data_reposicao) {
          this.aulaSelecionada.data_reposicao = this.aulaSelecionada.data_reposicao
            .split("-")
            .reverse()
            .join("/");
        }
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async getHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
          this.$route.params.gestaoDeAulaId
        );
        this.gestaoDeAula = response.payload.gestaoDeAula;

        const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;

        await this.buscarTodosHorarios();

        this.horariosSabado = response.payload.horarios
          .filter((h) => h.turno_id === turnoIdTurma)
          .map((h) => ({
            id: h.id,
            turno_id: h.turno_id,
            descricao: h.descricao.split(" - ")[0],
            final: h.final,
            inicio: h.inicio,
          }));

        if (this.gestaoDeAula.relacoesDiasHorarios) {
          this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
            (g) => g.dia.id
          );

          this.horariosDaGestao = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
          this.horarios = this.horariosDaGestao;
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar informações de horários");
      }
    },
    allowedDatesReposicao(val) {
      return new Date(val).getDay() === 5;
    },
    diaDaSemana() {
      const data_do_usuario = this.aulaSelecionada.data;
      const data_do_usuario_formatada = data_do_usuario.replace(/\//g, "-");
      const array1 = data_do_usuario_formatada.split("-");
      const array2 = array1.reverse();
      const data_final = new Date(array2[0], parseInt(array2[1], 10) - 1, array2[2]);
      const dia = this.diasSemana[data_final.getDay()];
      this.aulaSelecionada.dia_da_semana = dia;
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}

.calendar-container {
  max-width: 100%;
}

.calendar-card {
  width: 100%;
  max-width: 400px;
}

.events-card {
  max-height: 300px;
  overflow-y: auto;
}

.date-label {
  font-weight: bold;
  color: #1976d2;
  min-width: 50px;
}
</style>
